module.exports = __webpack_public_path__ + "static/media/order_blu_bar_inactive.4f41b91e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order_blu_bar_inactive.png
// module id = 1664
// module chunks = 0